'use es6';

import http from 'hub-http/clients/apiClient';
const FILE_MAPPER_API_BASE = 'content/filemapper/v1';
export function deployProject(folderPath) {
  return http.post(`${FILE_MAPPER_API_BASE}/deploy/${encodeURIComponent(folderPath)}`);
}